import { useAuth } from '@smarty/shared';

/**
 * Permiso transversal para acciones destructivas de gestión (borrado masivo, etc.).
 *
 * Política actual: dueño o gerente (`userRole in ('owner','manager')`), vía el helper
 * ya existente `useAuth().isOwnerOrManager()`. Se centraliza acá para que "quién puede
 * borrar/gestionar" viva en UN solo lugar — si mañana se quiere sumar un rol o un
 * permiso custom, se cambia solo este hook y todas las listas lo heredan.
 *
 * ⚠️ Es un gate de UI (oculta la acción). NO reemplaza la validación de servidor:
 * las RPC/RLS de borrado deben endurecerse aparte para impedir el bypass por API.
 */
export function useCanManage(): boolean {
  const { isOwnerOrManager } = useAuth();
  return isOwnerOrManager();
}
